module.exports = __webpack_public_path__ + "static/media/gain.ddfa6ea1.png";